import {
  SET_LAST_UPDATE_TIME,
  SET_USER_INFO,
  SET_DEVICE_SIZE,
  SET_LANGUAGE,
  SET_LANGUAGE_OBJ
} from '../actionTypes/commonTypes'
import { Base64 } from '@/utils/base64'
import {
  defaultLang,
  defaultLanguage,
  defaultPermissions,
  defaultPermissionsComplete,
  defaultUserName,
  defaultAccount,
  defaultRoles,
  langForceFlag
} from '@/utils/default'
let lang = defaultLang
if (localStorage.getItem(defaultLanguage) === 'zh_CN' || localStorage.getItem(defaultLanguage) === 'en_US') {
  // 防止莫名出现其他值
  lang = localStorage.getItem(defaultLanguage)
}
if (langForceFlag) {
  lang = defaultLang
}
const getVal = (key, empty) => {
  let res = ''
  try {
    res = (localStorage.getItem(key) && JSON.parse(Base64.decode(localStorage.getItem(key)))) || empty
  } catch (error) {
    res = empty
  }
  return res
}
const initState = {
  lastUpdateTime: '',
  account: localStorage.getItem(defaultAccount) || '',
  userName: localStorage.getItem(defaultUserName) || '',
  roles: getVal(defaultRoles, []),
  permissions: getVal(defaultPermissions, []),
  permissionsCompleteInfo: getVal(defaultPermissionsComplete, []),
  deviceSize: 1280 / 1280,
  language: lang,
  languageObj: {}
}
const commonReducer = (state = initState, action) => {
  const { type, payload } = action
  switch (type) {
    case SET_LAST_UPDATE_TIME:
      return {
        ...state,
        lastUpdateTime: payload
      }
    case SET_USER_INFO:
      return {
        ...state,
        userName: payload.userName,
        account: payload.account,
        permissions: JSON.parse(payload.permissions),
        permissionsCompleteInfo: JSON.parse(payload.permissionsCompleteInfo),
        roles: JSON.parse(payload.roles)
      }
    case SET_DEVICE_SIZE:
      return {
        ...state,
        deviceSize: payload
      }
    case SET_LANGUAGE:
      return {
        ...state,
        language: payload
      }
    case SET_LANGUAGE_OBJ:
      return {
        ...state,
        languageObj: payload
      }
    default:
      return {
        ...state
      }
  }
}

export default commonReducer
